<template>
  <div>
    <page-title
      icon="fa fa-leaf"
      main="Comercial"
      sub="Condição Comercial"
      :help="true"
      titleHelp="Ajuda - Condição Comercial"
      content="
        Tela responsável pela Condição Comercial.
        Para vincular Produtos Pai, selecione Vincular Produtos, selecionando o Nome/Produto Preferencial, escolhendo a marca dos produtos que serão vinculados, e selecione os botões localizados no meio da página para manipualação dos produtos que serão vinculados ao Produto Pai.
        Selecione uma data de Pagamento, junto a margem vegetal
        Para alterar as margens/juros basta ir com o mouse em ações e clicar em Editar Produtos'.
        Para alteração do vínculo de produtos basta ir com o mouse em ações e clicar em Vincular Produtos'.
      "
    >
      <template v-slot:actions>
        <base-button
          type="neutral"
          class="ml-3 mb-2"
          size="sm"
          @click="toggleProp"
          :disabled="!commercial.is_open"
          v-if="$can('update', 'commercials')"
          >Atualizar Siagri <i class= "fa fa-upload"></i>
        </base-button>
        <base-button
          color="red"
          type="neutral"
          @click="downloadPdf()"
          class="ml-3 text-red mb-2"
          size="sm"
          v-loading="isLoadingPdfDownload"
          >Gerar PDF <i class= "fa fa-file-pdf"></i>
        </base-button>
        <base-button v-if="currentUser.is_admin"
          type="neutral"
          @click="modals.sendPdf = true"
          class="ml-3 mb-2"
          size="sm"
          >Envio de PDF<i class= "fa fa-envelope-open-text"></i>
        </base-button>
        <base-button 
          v-if="$can('update', 'commercial_brand')"
          type="neutral"
          @click="openGroupedProductsModal()" class="ml-3  mb-2" size="sm"
          >Vincular Produtos
        </base-button>
      </template>
    </page-title>
    <brand-modal
      :show.sync="modals.brand"
      :commercial-brand.sync="commercialBrandValue"
      :commercial="commercial"
      :month-buy="monthBuy"
      :tables-erp="tablesErp"
      @submit="updateCommercialBrand"
      @close="resetCommercialBrand"
    />
    <send-pdf-modal 
      :show.sync="modals.sendPdf" 
      :commercial="commercial"
      :commercial_brand="filterBrand"
    />
    <grouped-products-modal
      :show.sync="modals.groupProducts"
      :commercial="commercial"
      :commercial-product.sync="productToAssociate"
      :commercial-brand="brandSelected"
      :editing="editing"
      @submit="handleGroupedProductsSubmit"
    />
    <product-modal
      :show.sync="modals.product"
      :commercial="commercial"
      :month-buy="monthBuy"
      :tables-erp="tablesErp"
      :commercial-products="productsToUpdate"
      :commercial-brand="brandSelected"
      @submit="updateCommercialProducts"
    />
    <filter-commercial
      v-model="commercial"
      @selected-brand="(commercialBrand) => { filterBrand = commercialBrand; getCommercialBrands(1, commercialBrand) }"
      @selected-commercial="filterCommercials"
    />
    <send-conditions-form
      :modalUpdatePrice.sync="modalUpdatePrice"
      :key="sendConditionsKey"
      :commercial="commercial"
      @modalupdate-price:update="modalUpdatePrice = false"
    />
    <!-- List commercial consitions -->
    <collapse
      class="commercial-card mt-2 bg-transparent"
      :multipleActive="false"
      v-loading="isLoadingCommercialBrands"
    >
      <collapse-item
        class="mb-2" 
        v-for="(brand, index) in commercialBrandsPaginatedData.data" 
        :key="`brand-${brand.id}`"
        :active="activeCollapseItem === index"
        @update:active="updateActiveState(index, $event)"
        @opening="activeCollapseItem = index; brandSelected = brand"
      >
        <div slot="title" class="row">
          <h4 class="mb-0 ml-2">
            {{ brand.name }}
          </h4>
          <div>
            <el-tooltip
              :disabled="$can('update', 'commercial_brand') && isBrandValid(brand)"
              effect="dark" placement="top"
            >  
              <template #content>
                <div v-if="!$can('update', 'commercial_brand')">Você  não tem permissão para editar</div>
                <div v-else-if="!isBrandValid(brand)">Marca possui produtos que necessitam de sua edição</div>
              </template>
              <base-button
                @click="editCommercialBrand(brand), $event.stopPropagation()"
                type="neutral"
                :disabled="!commercial.is_open || !$can('update', 'commercial_brand')"
                :class="{'ml-3': true, 'text-orange': !isBrandValid(brand)}"
                size="sm"
                >Editar Marca <i v-if="!isBrandValid(brand)" class= "fa fa-exclamation-triangle"></i>
              </base-button>
            </el-tooltip>
            <base-button
              @click="editCommercialProducts()"
              type="neutral"
              class="ml-3"
              size="sm"
              :disabled="!commercial.is_open || !$can('update', 'commercial_product')"
              >Atualizar Selecionados
            </base-button>
            <small v-show="!commercial.is_open" class="text-warning">Atenção! Período comercial encontra-se fechado</small>
          </div>
        </div>
        <commercial-brand-table
          v-if="activeCollapseItem == index"
          :commercial="commercial"
          :commercial-brand="brand"
          :month-buy="monthBuy"
          :selected-products.sync="productsToUpdate"
          @edit="editCommercialProducts"
          @assign-products="openGroupedProductsModal"
        />
      </collapse-item>
    </collapse>
    <div slot="footer" class="pt-4">
      <base-pagination
        class="justify-content-end"
        v-on:input="getCommercialBrands"
        :value="commercialBrandsPaginatedData.page"
        :total="commercialBrandsPaginatedData.count"
        :perPage="commercialBrandsPaginatedData.per_page"
      ></base-pagination>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import FilterCommercial from "./Filter";
import BrandModal from "./BrandModal.vue";
import ProductModal from "./ProductModal.vue";
import moment from "moment";
import GroupedProductsModal from "./GroupedProductsModal.vue";
import SendPdfModal from "./SendPdfModal.vue";
import SendConditionsForm from "./SendConditionsForm.vue";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import CommercialBrandTable from "../../components/Commercial/CommercialBrandTable.vue";

export default {
  components: {
    FilterCommercial,
    Multiselect,
    PageTitle,
    Collapse,
    CollapseItem,
    BrandModal,
    ProductModal,
    GroupedProductsModal,
    SendPdfModal,
    BaseInput,
    SendConditionsForm,
    CommercialBrandTable,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      filterBrand: null,
      productToAssociate: null,
      activeCollapseItem: -1,
      modals: {
        brand: false,
        product: false,
        groupProducts: false,
        sendPdf: false,
      },
      currentUser: {},
      brands: [],
      isLoading: false,
      isLoadingPdfDownload: false,
      listing: false,
      brandSelected: {},
      monthBuy: [],
      modalUpdatePrice: false,
      monthName: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      commercial: {},
      commercialBrands: [],
      commercialBrandValue: {},
      filtered: [],
      sendConditionsKey: 0,
      updatedGainMargin: "",
      commercialBrandsPaginatedData: [],
      productsToUpdate: [],
      isLoadingCommercialBrands: false,
      editing: false,
    };
  },
  mounted() {
    this.currentUser = this.$currentUser();
  },
  methods: {
    handleGroupedProductsSubmit() {
      this.getCommercialBrands()
      this.resetBrandSelection()
    },
    updateActiveState(index, isActive) {
      if (!isActive) {
        this.activeCollapseItem = -1;
      } else {
        this.activeCollapseItem = index;
      }
    },
    async updateCommercialProducts(commercialProductData) {
      const commercialProductIds = this.productsToUpdate.map((el) => el.id)

      try {
        await this.$http.secured.patch(
          `/api/v2/commercial_products/update_multiple`,
          { 
            commercial_product_ids: commercialProductIds,
            commercial_product: commercialProductData
          }
        )

        this.resetBrandSelection()
        this.$toasted.global.defaultSuccess({ msg: "Operação realizada com sucesso!" });

      } catch(error) {
        console.log(error)
      }
    },
    async updateCommercialBrand(formData) {
      try {
        await this.$http.secured.patch(
          `/api/v2/commercial_brands/${this.commercialBrandValue.id}`,
          { commercial_brand: formData }
        )
        
        this.activeCollapseItem = -1
        this.$toasted.global.defaultSuccess({ msg: "Operação realizada com sucesso!" });
      } catch (error) {
        console.log(error)
      }
    },
    async getCommercialBrands(page = 1, commercialBrandId = null) {
      if(!this.commercial.id) return;
      
      const q = { commercial_id: this.commercial.id}
      if (commercialBrandId) q.id = commercialBrandId

      try {
        this.isLoadingCommercialBrands = true;
        const response = await this.$http.secured.get("/api/v2/commercial_brands", {
          params: {
            q: q,
            page: page
          },
        })
        this.commercialBrandsPaginatedData = response.data
        this.brands = response.data.data
      } catch (error) {
       console.log(error)
      } finally {
        this.isLoadingCommercialBrands = false;
      }
    },
    editCommercialBrand(commercialBrand) {
      this.commercialBrandValue = commercialBrand;
      this.modals.brand = true;
    },
    openGroupedProductsModal(commercialProduct = null) {
      this.editing = false;
      this.modals.groupProducts = true;
      if (commercialProduct) this.editing = true;
      this.productToAssociate = commercialProduct
    },
    filterCommercials(commercial) {
      this.commercial = commercial

      if (!commercial.id) {
        this.commercialBrandsPaginatedData = []
        return
      }

      this.getCommercialBrands();
    },
    async downloadPdf() {
      this.isLoadingPdfDownload = true;
      try {
        const response = await this.$http.secured.get(`/api/v1/commercials/${this.commercial.id}.pdf`, {
          params: {
            q: {commercial_id: this.commercial.id},
            commercial_brand_id: this.filterBrand ? this.filterBrand : null
          },
          responseType: "arraybuffer",
        });

        // Starting file donwload
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `CONDIÇÃO COMERCIAL - ${this.commercial && this.commercial.name}.pdf`
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      }
      this.isLoadingPdfDownload = false;
    },
    generatePeriodMonths() {
      var startDate = moment(this.commercial.initial_date);
      var endDate   = moment(this.commercial.final_date);
      var today = moment()
      var cutoffDay = 25;

      if (endDate.date() >= cutoffDay) {
        endDate.add(1, "month");
      }

      var result = [];
      var isAfterCutoff = today.date() >= cutoffDay;
      var referenceDate = isAfterCutoff ? today : today.subtract(1, 'month');

      referenceDate.date(cutoffDay).startOf('day');

      while (startDate.isSameOrBefore(endDate)) {

        var formattedDate = startDate.format("YYYY-MM-10");
        var momentDate = moment(formattedDate);
        
        if (momentDate.isSameOrAfter(referenceDate)) {
          result.push(formattedDate);
        }
        
        startDate.add(1, "month");
      }

      this.monthBuy = result.map((e) => {
        let iDate = new Date(e);

        return this.monthName[iDate.getMonth()] + " " + iDate.getFullYear();
      });
    },
    toggleProp() {
      this.modalUpdatePrice = true;
      this.sendConditionsKey += 1;
    },
    editCommercialProducts(commercialProduct = null) {
      if (commercialProduct) this.productsToUpdate = [commercialProduct];

      this.modals.product = true;
    },
    isBrandValid(commercialBrand) {
      if (!commercialBrand) return false;

      return !!commercialBrand.payment_date && !!commercialBrand.purchase_cost_date
    },
    resetBrandSelection(){
      this.brandSelected = {}
      this.activeCollapseItem = -1
    },
    resetCommercialBrand() {
      this.commercialBrandValue = {}
    },
  },
  computed: {
    tablesErp() {
      if (this.commercial && !this.commercial.commercial_table) return [];

      return this.commercial && this.commercial.commercial_table;
    },
  },
  watch: {
    commercial: {
      handler() {
        this.generatePeriodMonths();
      },
    },
    brandSelected: {
      handler() {
        this.productsToUpdate = []
      },
    }
  },
};
</script>
<style scoped>
.card {
  margin-bottom: 0px;
  border-radius: 4px !important;
}
:deep(.el-table__fixed),
:deep(.el-table__fixed-right) {
  background-color: white;
}
:deep(.el-table__fixed .el-table__header th),
:deep(.el-table__fixed-right .el-table__header th) {
  height: 42px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.yearStart {
  float: right;
  margin-right: 5px;
}
.labelYear {
  padding-right: 5px;
}
:deep(.el-table__body .el-table__row .cell),
:deep(.el-table__header thead th > .cell) {
  height: 32px;
}
</style>
<style lang="scss">
.commercial-card {
  .card-body {
    padding: 0;
  }
}
</style>
